import { render, staticRenderFns } from "./RelatorioLogOperacoesRetrato.vue?vue&type=template&id=72a4e4db"
import script from "./RelatorioLogOperacoesRetrato.vue?vue&type=script&lang=js"
export * from "./RelatorioLogOperacoesRetrato.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogOperacoesRetrato.vue?vue&type=style&index=0&id=72a4e4db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports